module.exports = {
  web: [
    {
      url: "https://zentrumfuerliterarischegegenwart.ch",
      label: "Zentrum für Literarische Gegenwart"
    },
    {
      url: "https://zurichaestheticslab.ch",
      label: "Zurich Aesthetics Lab"
    },
    { url: "https://lisachrist.ch", label: "Lisa Christ" },
    {
      url: "https://www.helvetialuzern.ch/en",
      label: "Restaurant Helvetia Luzern"
    },
    { url: "https://emmeneggerarch.ch/", label: "Emmenegger Architekten" },
    { url: "https://kiff.ch", label: "Kiff" },
    { url: "https://upset.ch", label: "Upset" },
    { url: "https://versive.cc", label: "Versive" }
  ],
  physical: [
    {
      url: "http://www.kunstbetrieb.ch/en/vanessa-billy-2021/",
      label: "Chains, Vanessa Billy"
    },
    {
      url: "http://www.kunstbetrieb.ch/en/maitha-abdalla-2023/",
      label: "The Dancer’s Skin, Maitha Abdalla"
    }
  ],
  teaching: [
    {
      url: "https://github.com/logrinto/IAD2017.projektwoche.kontext",
      label: "SfGZ IAD2017 – Kontext "
    }
  ]
};



// WEBPACK FOOTER //
// ./src/data/projects.js